The details of the candidate to be verified.
